import authConfig from "emun.auth/auth.config"; //get shared
import resetPasswordPrompt from "emun.auth/reset-password/reset-password-prompt";
import basicController from "servicestack/basic.controller.properties";
import actionsTemplateUrl from "emun.auth/register-current-acct-actions.htm";
import fieldsetTemplateUrl from "emun.auth/register-current-acct-fieldset.htm";
import labels from "emun.auth/register-current-acct.labels";
import modals from "webmodals/modals";

export default class RegisterCurrentAcctPromptController {
  constructor($scope /*, options*/) {
    basicController(this);
    const $ctrl = this;
    $ctrl.bus = $ctrl.$session.bus;
    delete $ctrl.bus.validationErrors;
    $ctrl.config = authConfig;
    $ctrl.labels = labels;
    $ctrl.actionsTemplateUrl = actionsTemplateUrl;
    $ctrl.fieldsetTemplateUrl = fieldsetTemplateUrl;
    // $ctrl.title = options.title || "For ALL Accounts";
    $ctrl.request = {
      role: "Retailer",
      autoLogin: false,
      email: $ctrl.email,
      //userName: $ctrl.userName,
      billing: { country: "US" },
      shipping: { country: "US" },
      password: "RESET",
      confirmPassword: "RESET",
      forceResetPassword: true,
      ...labels.defaultRequest,
    };
    $scope.$watch(
      () =>
        `${$ctrl.request.email}|${$ctrl.request.retailerId}|${$ctrl.request.billingZip}`,
      () =>
        ($ctrl.request.email ||
          $ctrl.request.retailerId ||
          $ctrl.request.billingZip) &&
        $ctrl.validate()
    );
    // $scope.$watch(
    //   () => $ctrl.request.email,
    //   () => $ctrl.queryRegistrationEmails()
    // );
    // console.debug("RegisterCurrentAcctPromptController", this);
  }

  submit() {
    const $ctrl = this;
    $ctrl.request.dontBroadcast = true;
    $ctrl.request.context = "RegisterCurrentAccount";
    return $ctrl.$session.register($ctrl.request).then(
      (res) => {
        // if ($ctrl.redirectAfterAuthentication) {
        //   window.location.href = $ctrl.redirectAfterAuthentication;
        // }
        $ctrl.$close && $ctrl.$close(res);
        return modals
          .alert(
            labels.confirmationMessage ||
              "Thanks for registering. Check your email to set your password.",
            "Account verified"
          )
          .result.then(() => {
            location.href =
              $ctrl.redirectAfterAuthentication ||
              "/?registered=" + new Date().getTime(); //go home
          });
      },
      (res) => console.warn("no auth", $ctrl)
    );
  }

  queryRegistrationEmails() {
    const $ctrl = this;
    const { request } = $ctrl;
    return (
      0 &&
      $ctrl.bus
        .read(`QueryRegistrationEmails/${request.email}`)
        .then(({ data }) => {
          console.debug("QueryRegistrationEmails", data);
          if (data.length) {
            const [retailerId] = data;
            request.retailerId = retailerId;
            $ctrl.$notify.info(
              "We located the account number linked to your email address.",
              {
                title: retailerId,
                ttl: 5000,
              }
            );
          }
        })
    );
  }

  validate() {
    const $ctrl = this;
    const { request } = $ctrl;
    return $ctrl.bus.validate(`auth/register/${request.role}.json`, request);
  }

  resetPassword() {
    const $ctrl = this;
    $ctrl.$dismiss && $ctrl.$dismiss("resetPassword");
    return resetPasswordPrompt({ email: $ctrl.request.email });
  }

  setFocus(id) {
    let $ctrl = this;
    setTimeout(function () {
      var element = window.document.getElementById(id);
      if (element) {
        element.focus();
      }
    }, 500);
  }
}
